const ListOfFeatures = ({ data }) => {
  return (
    <div className="list-of-features">{data}</div>
  );
};

export default ListOfFeatures;
